export default {
  form: {
    address: {
      label: 'Morada',
      placeholder: 'Morada',
    },
    zip_code: {
      label: 'Código postal',
      placeholder: 'Código postal',
    },
    city: {
      label: 'Cidade',
      placeholder: 'Cidade',
    },
    start_time: {
      label: 'Hora de início',
      placeholder: 'ex.: 11:00',
    },
    name: {
      label: 'Nome da localização (opcional)',
      placeholder: 'ex.: Junto à Fernsehturm',
      tooltip:
        'Introduzir um nome de localização pode ajudar os clientes a identificar o local, ex.: «Junto à Fernsehturm»',
    },
    note: {
      label: 'Nota',
      placeholder: 'Introduzir nota',
    },
  },
  buttons: {
    add_location: 'Adicionar localização',
  },
};
